import React from 'react';

import dayjs from 'dayjs';
import { CompanyLogo } from '@ibinder/ui-common-core';
import { iBinderMainTheme } from '@ibinder/ui-common-styles';
import { StyledFooter } from './Footer.styles';

export const Footer = () => {
  const company = 'iBinder';
  const year = dayjs().year();

  const getCopyright = () => {
    return `${year} iBinder.com`;
  };

  return (
    <StyledFooter
      image={<CompanyLogo company={company.toLowerCase()} withText={true} />}
      copyRight={getCopyright()}
      loading={false}
    />
  );
};
